import React from "react";
import {PaymentDistribution} from 'us.collection.transactions/components'
interface ICnt_CaseDetailView {
  caseNo: number;
}

const Cnt_PaymentDistribution: React.FC<ICnt_CaseDetailView> = (props) => {

  return (
    <>
      <PaymentDistribution />
    </>
  );
};

export default Cnt_PaymentDistribution;
